import { ConnectableObject } from '@ikea-aoa/component-view-3d/lib/main/connection-manager';
import { SceneObject } from '@ikea-aoa/component-view-3d';

export class ConnectedModule {
	public connection: {
		from: string;
		to: string;
	};
	constructor(from: string, to: string, public object: SceneObject) {
		this.connection = {
			from,
			to,
		};
	}
}

/**
 * Module Connections Class.
 * The class is used to store all connections between module items.
 */
export class ModuleConnections {
	constructor(private sceneItems: Map<string, ConnectableObject>) {}
	private connectionModules = new Map<string, Array<ConnectedModule>>();

	public add(id: string, connectedModule: ConnectedModule): void {
		const { object, connection } = connectedModule;
		this.saveModule(id, connectedModule);
		const item = this.sceneItems.get(id);
		if (item) {
			this.saveModule(object.id, new ConnectedModule(connection.to, connection.from, item));
		} else {
			throw 'ModuleConnections: add(): item does not exist';
		}
	}

	public delete(id: string): void {
		this.connectionModules.delete(id);
		this.connectionModules.forEach((array) => this.deleteFromArray(array, id));
	}

	public has(id: string): boolean {
		return this.connectionModules.has(id);
	}

	public get(id: string): Array<ConnectableObject> {
		const connnections = this.connectionModules.get(id);
		if (connnections) {
			return connnections.map((con) => con.object);
		}
		return [];
	}

	public getModules(id: string): Array<ConnectedModule> {
		const connnections = this.connectionModules.get(id);
		if (connnections) {
			return connnections;
		}
		return [];
	}

	public clear(): void {
		this.connectionModules.clear();
	}

	private saveModule(id: string, ...connections: ConnectedModule[]): void {
		if (this.connectionModules.has(id)) {
			const con = this.connectionModules.get(id);
			if (con) {
				connections.forEach((item) => {
					const itemExist = con.find((connection) => {
						return (
							connection.connection.from === item.connection.from &&
							connection.connection.to === item.connection.to &&
							connection.object.id === item.object.id
						);
					});
					// Don't add duplicate connections
					if (!itemExist) {
						con.push(item);
					}
				});
			} else {
				throw 'ModuleConnections: saveModule(): con does not exist';
			}
		} else {
			this.connectionModules.set(id, [...connections]);
		}
	}

	private deleteFromArray(array: ConnectedModule[], id: string): void {
		let index = array.findIndex((module) => module.object.id == id);
		while (index !== -1) {
			array.splice(index, 1);
			index = array.findIndex((module) => module.object.id == id);
		}
	}
}
